'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pullout = require('../../pullout');

var _pullout2 = _interopRequireDefault(_pullout);

var _mediaButton = require('../../../atoms/media-button');

var _mediaButton2 = _interopRequireDefault(_mediaButton);

var _actionDropdown = require('../../../molecules/action-dropdown');

var _actionDropdown2 = _interopRequireDefault(_actionDropdown);

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'fees-pullout';

var renderActionDropdown = function renderActionDropdown(actionDropdown, callback) {
  if (actionDropdown) {
    return _react2.default.createElement(_actionDropdown2.default, _extends({}, actionDropdown, { callback: callback }));
  }
  return null;
};

var renderMediaButton = function renderMediaButton(mediaButton) {
  if (mediaButton) {
    var color = mediaButton.color || 'outline-white';
    var buttonClass = (0, _classnames2.default)('pullout__media-btn', 'pullout__btn--center', 'pypl-btn--' + color);

    return _react2.default.createElement(
      _mediaButton2.default,
      {
        id: mediaButton.id,
        color: 'outline-white',
        className: buttonClass,
        fpti: 'Pullout-MediaBtn-' + (mediaButton.fpti || mediaButton.text),
        'data-video-id': mediaButton['data-video-id']
      },
      mediaButton.text
    );
  }
  return null;
};

var FeesPullout = function (_Pullout) {
  _inherits(FeesPullout, _Pullout);

  function FeesPullout(props) {
    _classCallCheck(this, FeesPullout);

    var _this = _possibleConstructorReturn(this, (FeesPullout.__proto__ || Object.getPrototypeOf(FeesPullout)).call(this, props));

    _this.renderActionDropdown = renderActionDropdown;
    _this.renderMediaButton = renderMediaButton;
    return _this;
  }

  _createClass(FeesPullout, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className,
          clientInfo = _props.clientInfo,
          callback = _props.callback;
      var image = content.image,
          headline = content.headline,
          paragraph = content.paragraph,
          cta = content.cta,
          mediaButton = content.mediaButton,
          hatchText = content.hatchText,
          actionDropdown = content.actionDropdown;


      config.theme = config.theme || 'theme-background-color-dark';

      var viewport = clientInfo.client_type;
      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);
      var backgroundPosition = config.backgroundImage && config.backgroundPosition;
      var backgroundImageStyle = this.state.showImages && backgroundImage ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;
      var pulloutClasses = (0, _classnames2.default)('' + ORGANISM_NAME, 'pullout', className, config.theme);

      return _react2.default.createElement(
        'section',
        {
          className: pulloutClasses,
          id: this.props.config.id,
          'data-building-block': 'organism',
          style: backgroundImageStyle,
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-lg-12 center-block text-xs-center' },
              this.renderImage(image),
              this.renderHeadline(headline),
              this.renderContent(paragraph),
              this.renderActionDropdown(actionDropdown, callback),
              this.renderCTA(cta),
              this.renderMediaButton(mediaButton),
              this.renderHatchContent(hatchText)
            )
          )
        )
      );
    }
  }]);

  return FeesPullout;
}(_pullout2.default);

exports.default = FeesPullout;


FeesPullout.propTypes = {
  content: _propTypes2.default.shape({
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string
    }),
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    actionDropdown: _actionDropdown2.default.propTypes.isRequired,
    cta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string,
      text: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    mediaButton: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  clientInfo: _propTypes2.default.shape({
    client_type: _propTypes2.default.string
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-image-dark', 'theme-background-image-light', 'theme-background-color-dark', 'theme-background-color-green', 'theme-background-color-blue-alt', 'theme-background-color-pink', 'theme-background-color-purple']),
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string,
      mobile: _propTypes2.default.string
    }),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right'])
  }),
  className: _propTypes2.default.string,
  callback: _propTypes2.default.func
};

FeesPullout.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/fees-pullout/jsx/FeesPullout.js
// module id = 1091
// module chunks = 4